'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _dec, _class2, _class3, _temp;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxForm = require('redux-form');

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _forms = require('metadata/forms');

var _forms2 = require('utils/forms');

var _components2 = require('components');

var _utils = require('../../../utils/mappings/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    CovidRequirement: {
        displayName: 'CovidRequirement'
    },
    TravelReady: {
        displayName: 'TravelReady'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/Users/gareth.chou/Documents/GAdventures/g-rex/app/components/RequirementSet/forms/TravelReady.js',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var covidComplianceOfEntryAcknowledgement = _react3.default.createElement(_reactIntl.FormattedMessage, {
    id: 'formTravelReady.covidComplianceOfEntryAcknowledgement',
    defaultMessage: '{stubText}',
    values: {
        stubText: _react3.default.createElement(
            'div',
            null,
            _react3.default.createElement(
                'p',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'formTravelReady.covidComplianceOfEntryAcknowledgementText',
                    defaultMessage: 'You acknowledge that you are responsible for ensuring that you meet all applicable entry requirements in effect at the time of travel, including with respect to vaccines and/or COVID-19 testing requirements. Information can be found on your country\u2019s foreign travel advice website and on gadventures.com.' })
            )
        )
    }
});

var covidScreeningAcknowledgement = function covidScreeningAcknowledgement(bookingCompany, language, isPrimaryCustomerLoading, countryCode) {
    return _react3.default.createElement(_reactIntl.FormattedMessage, {
        id: 'formTravelReady.covidScreeningAcknowledgement',
        defaultMessage: '{stubText}',
        values: {
            stubText: _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(
                    'p',
                    null,
                    'You acknowledge:'
                ),
                _react3.default.createElement(
                    'ul',
                    null,
                    !isPrimaryCustomerLoading && (0, _utils.getTravelAcknowledgementsWithLinks)(bookingCompany.id, language, countryCode).map(function (item, index) {
                        return _react3.default.createElement(
                            'li',
                            { key: index },
                            item
                        );
                    })
                )
            )
        }
    });
};

var maskWearingAcknowledgement = _react3.default.createElement(_reactIntl.FormattedMessage, {
    id: 'formTravelReady.maskWearingAcknowledgement',
    defaultMessage: '{stubText}',
    values: {
        stubText: _react3.default.createElement(
            'div',
            null,
            _react3.default.createElement(
                'p',
                null,
                'You acknowledge that you will be required to wear a face mask in accordance with local regulations.',
                _react3.default.createElement(
                    'ul',
                    null,
                    _react3.default.createElement(
                        'li',
                        null,
                        'Yes, I\u2019m aware that I will be required to wear a face mask where required by local regulations and will abide by these.'
                    ),
                    _react3.default.createElement(
                        'li',
                        null,
                        'Or; I am not able to comply with local regulations for mask-wearing requirements and would like to speak to someone about my options. I understand that by ticking this box and not wearing a face mask I may be denied participation in my tour.'
                    )
                )
            )
        )
    }
});

var covidVaccinated = _react3.default.createElement(_reactIntl.FormattedMessage, {
    id: 'formTravelReady.covidVaccinatedMain',
    defaultMessage: '{stubText}',
    values: {
        stubText: _react3.default.createElement(
            'div',
            null,
            _react3.default.createElement(
                'p',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'formTravelReady.covidVaccinatedMainText',
                    defaultMessage: 'To participate, you acknowledge that you are fully COVID-19 vaccinated (as defined by your country of residence) with the final dose given at least 14 days before your tour start date.' })
            )
        )
    }
});

var covidVaccinatedOrPcrTest = _react3.default.createElement(_reactIntl.FormattedMessage, {
    id: 'formTravelReady.covidVaccinatedOrPcrTestMain',
    defaultMessage: '{stubText}',
    values: {
        stubText: _react3.default.createElement(
            'div',
            null,
            _react3.default.createElement(
                'p',
                null,
                _react3.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'formTravelReady.covidVaccinatedOrPcrTestMainText',
                    defaultMessage: 'You acknowledge that in order to participate in this G Adventures tour, you must comply with G Adventures Travel-Ready policy, I confirm that I currently have or will have: ' })
            )
        )
    }
});

var CovidRequirement = _wrapComponent('CovidRequirement')((0, _reactIntl.injectIntl)(_class = function (_Component) {
    (0, _inherits3.default)(CovidRequirement, _Component);

    function CovidRequirement(props) {
        (0, _classCallCheck3.default)(this, CovidRequirement);
        return (0, _possibleConstructorReturn3.default)(this, (CovidRequirement.__proto__ || (0, _getPrototypeOf2.default)(CovidRequirement)).call(this, props));
    }

    (0, _createClass3.default)(CovidRequirement, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                bookingId = _props.bookingId,
                initialValues = _props.initialValues,
                intl = _props.intl,
                req = _props.req,
                tourName = _props.tourName;


            var code = req.code;

            return null;
        }
    }]);
    return CovidRequirement;
}(_react2.Component)) || _class);

var TravelReady = _wrapComponent('TravelReady')((_dec = (0, _reduxForm.reduxForm)({
    form: 'TravelReady',
    enableReinitialize: true
}), _dec(_class2 = (0, _reactIntl.injectIntl)(_class2 = (_temp = _class3 = function (_Component2) {
    (0, _inherits3.default)(TravelReady, _Component2);

    function TravelReady(props) {
        (0, _classCallCheck3.default)(this, TravelReady);

        var _this2 = (0, _possibleConstructorReturn3.default)(this, (TravelReady.__proto__ || (0, _getPrototypeOf2.default)(TravelReady)).call(this, props));

        _this2.state = {};
        return _this2;
    }

    (0, _createClass3.default)(TravelReady, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.initializeStateProps(this.props);
        }
    }, {
        key: 'initializeStateProps',
        value: function initializeStateProps(_ref) {
            var requirementsByCode = _ref.requirementsByCode;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                intl = _props2.intl,
                initialValues = _props2.initialValues,
                hiddenValues = _props2.hiddenValues,
                checkinUrl = _props2.checkinUrl,
                requirementsByCode = _props2.requirementsByCode,
                bookingId = _props2.bookingId,
                language = _props2.language,
                countryCode = _props2.countryCode,
                isPrimaryCustomerLoading = _props2.isPrimaryCustomerLoading,
                isFetchingRequirementData = _props2.isFetchingRequirementData,
                handleSubmit = _props2.handleSubmit,
                error = _props2.error,
                invalid = _props2.invalid,
                pristine = _props2.pristine,
                submitSucceeded = _props2.submitSucceeded,
                submitFailed = _props2.submitFailed,
                submitting = _props2.submitting,
                departureServicesById = _props2.departureServicesById,
                bookingCompany = _props2.bookingCompany;

            var covidComplianceOfEntryReq = requirementsByCode.COVID_COMPLIANCE_OF_ENTRY;
            var covidScreeningReq = requirementsByCode.COVID_SCREENING_ACKNOWLEDGEMENT;
            var maskWearingReq = requirementsByCode.MASK_WEARING_ACKNOWLEDGEMENT;
            var covidVaccinated30DaysReq = requirementsByCode.COVID_VACCINATED_30_DAYS;
            var covidVaccinated120DaysReq = requirementsByCode.COVID_VACCINATED_120_DAYS;
            var covidVaccinatedOrPcrTest30DaysReq = requirementsByCode.COVID_VACCINATED_OR_PCR_TEST_30_DAYS;
            var covidFdaVaccinated120DaysReq = requirementsByCode.COVID_FDA_VACCINATED_120_DAYS;
            var covidFdaVaccinatedOrPcrTest120DaysReq = requirementsByCode.COVID_FDA_VACCINATED_OR_PCR_TEST_120_DAYS;
            return _react3.default.createElement(
                'div',
                null,
                _react3.default.createElement(_components2.FormErrorMessage, { errorCode: error, invalid: invalid, submitFailed: submitFailed, submitting: submitting }),
                _react3.default.createElement(
                    'form',
                    null,
                    _react3.default.createElement(_components2.FieldSet, {
                        requirement: covidComplianceOfEntryReq,
                        fields: [{
                            id: 'covidComplianceOfEntry',
                            label: _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formTravelReady.covidComplianceOfEntry',
                                defaultMessage: 'COVID Compliance of Entry' }),
                            field: _react3.default.createElement(_components2.FormStubText, { stubText: covidComplianceOfEntryAcknowledgement })
                        }, (0, _extends3.default)({}, (0, _forms2.generateOverride)({
                            intl: intl,
                            id: 'covidComplianceOfEntryOverride',
                            requirement: covidComplianceOfEntryReq,
                            overrideLabels: _forms.formOverrides.travelReady.COVID_COMPLIANCE_OF_ENTRY,
                            bookingId: bookingId,
                            initialValues: initialValues
                        }))] }),
                    _react3.default.createElement(_components2.FieldSet, {
                        requirement: covidScreeningReq,

                        fields: [{
                            id: 'covidScreening',
                            label: _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formTravelReady.covidScreening',
                                defaultMessage: 'Acknowledgements' }),
                            field: _react3.default.createElement(_components2.FormStubText, { stubText: covidScreeningAcknowledgement(bookingCompany, language, isPrimaryCustomerLoading, countryCode) })
                        }, (0, _extends3.default)({}, (0, _forms2.generateOverride)({
                            intl: intl,
                            id: 'covidScreeningOverride',
                            requirement: covidScreeningReq,
                            overrideLabels: _forms.formOverrides.travelReady.COVID_SCREENING_ACKNOWLEDGEMENT,
                            bookingId: bookingId,
                            initialValues: initialValues
                        }))] }),
                    _react3.default.createElement(_components2.FieldSet, {
                        requirement: maskWearingReq,
                        fields: [{
                            id: 'maskWearing',
                            label: _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formTravelReady.maskWearing',
                                defaultMessage: 'Mask Wearing Acknowledgement' }),
                            field: _react3.default.createElement(_components2.FormStubText, { stubText: maskWearingAcknowledgement })
                        }, (0, _extends3.default)({}, (0, _forms2.generateOverride)({
                            intl: intl,
                            id: 'maskWearingOverride',
                            requirement: maskWearingReq,
                            overrideLabels: _forms.formOverrides.travelReady.MASK_WEARING_ACKNOWLEDGEMENT,
                            bookingId: bookingId,
                            initialValues: initialValues
                        }))] }),
                    _react3.default.createElement(_components2.FieldSet, {
                        requirement: covidVaccinated30DaysReq,
                        fields: [{
                            id: 'covidVaccinated30Days',
                            label: _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formTravelReady.covidVaccinated30Days',
                                defaultMessage: 'Travel Ready Acknowledgement' }),
                            field: _react3.default.createElement(_components2.FormStubText, { stubText: covidVaccinated })
                        }, (0, _extends3.default)({}, (0, _forms2.generateOverride)({
                            intl: intl,
                            id: 'covidVaccinated30DaysOverride',
                            requirement: covidVaccinated30DaysReq,
                            overrideLabels: _forms.formOverrides.travelReady.COVID_VACCINATED_30_DAYS,
                            bookingId: bookingId,
                            initialValues: initialValues
                        }))] }),
                    _react3.default.createElement(_components2.FieldSet, {
                        requirement: covidVaccinated120DaysReq,
                        fields: [{
                            id: 'covidVaccinated120Days',
                            label: _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formTravelReady.covidVaccinated120Days',
                                defaultMessage: 'Travel Ready Acknowledgement' }),
                            field: _react3.default.createElement(_components2.FormStubText, { stubText: covidVaccinated })
                        }, (0, _extends3.default)({}, (0, _forms2.generateOverride)({
                            intl: intl,
                            id: 'covidVaccinated120DaysOverride',
                            requirement: covidVaccinated120DaysReq,
                            overrideLabels: _forms.formOverrides.travelReady.COVID_VACCINATED_120_DAYS,
                            bookingId: bookingId,
                            initialValues: initialValues
                        }))] }),
                    _react3.default.createElement(_components2.FieldSet, {
                        requirement: covidVaccinatedOrPcrTest30DaysReq,
                        fields: [{
                            id: 'covidVaccinatedOrPcrTest30Days',
                            label: _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formTravelReady.covidVaccinatedOrPcrTest30Days',
                                defaultMessage: 'Travel Ready Acknowledgement' }),
                            field: _react3.default.createElement(_components2.FormStubText, { stubText: covidVaccinatedOrPcrTest })
                        }, (0, _extends3.default)({}, (0, _forms2.generateOverride)({
                            intl: intl,
                            id: 'covidVaccinatedOrPcrTest30DaysOverride',
                            requirement: covidVaccinatedOrPcrTest30DaysReq,
                            overrideLabels: _forms.formOverrides.travelReady.COVID_VACCINATED_OR_PCR_TEST_30_DAYS,
                            bookingId: bookingId,
                            initialValues: initialValues
                        }))] }),
                    _react3.default.createElement(_components2.FieldSet, {
                        requirement: covidFdaVaccinated120DaysReq,
                        fields: [{
                            id: 'covidFdaVaccinated120Days',
                            label: _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formTravelReady.covidFdaVaccinated120Days',
                                defaultMessage: 'Travel Ready Acknowledgement' }),
                            field: _react3.default.createElement(_components2.FormStubText, { stubText: covidVaccinated })
                        }, (0, _extends3.default)({}, (0, _forms2.generateOverride)({
                            intl: intl,
                            id: 'covidFdaVaccinated120DaysOverride',
                            requirement: covidFdaVaccinated120DaysReq,
                            overrideLabels: _forms.formOverrides.travelReady.COVID_FDA_VACCINATED_120_DAYS,
                            bookingId: bookingId,
                            initialValues: initialValues
                        }))] }),
                    _react3.default.createElement(_components2.FieldSet, {
                        requirement: covidFdaVaccinatedOrPcrTest120DaysReq,
                        fields: [{
                            id: 'covidFdaVaccinatedOrPcrTest120Days',
                            label: _react3.default.createElement(_reactIntl.FormattedMessage, {
                                id: 'formTravelReady.covidFdaVaccinatedOrPcrTest120Days',
                                defaultMessage: 'Travel Ready Acknowledgement' }),
                            field: _react3.default.createElement(_components2.FormStubText, { stubText: covidVaccinatedOrPcrTest })
                        }, (0, _extends3.default)({}, (0, _forms2.generateOverride)({
                            intl: intl,
                            id: 'covidFdaVaccinatedOrPcrTest120DaysOverride',
                            requirement: covidFdaVaccinatedOrPcrTest120DaysReq,
                            overrideLabels: _forms.formOverrides.travelReady.COVID_FDA_VACCINATED_OR_PCR_TEST_120_DAYS,
                            bookingId: bookingId,
                            initialValues: initialValues
                        }))] }),
                    _react3.default.createElement(_components2.FormSubmit, {
                        handleSubmit: handleSubmit,
                        invalid: invalid,
                        pristine: pristine,
                        submitting: submitting,
                        submitSucceeded: submitSucceeded,
                        isFetchingRequirementData: isFetchingRequirementData })
                )
            );
        }
    }]);
    return TravelReady;
}(_react2.Component), _class3.propTypes = {
    intl: _propTypes2.default.object.isRequired,
    initialValues: _propTypes2.default.object.isRequired,
    hiddenValues: _propTypes2.default.object.isRequired,
    requirementsByCode: _propTypes2.default.object.isRequired,
    bookingId: _propTypes2.default.string.isRequired,
    language: _propTypes2.default.string.isRequired,
    countryCode: _propTypes2.default.string.isRequired,
    isPrimaryCustomerLoading: _propTypes2.default.bool.isRequired,
    isFetchingRequirementData: _propTypes2.default.bool.isRequired,
    handleSubmit: _propTypes2.default.func.isRequired,
    error: _propTypes2.default.string,
    invalid: _propTypes2.default.bool,
    pristine: _propTypes2.default.bool,
    submitting: _propTypes2.default.bool,
    submitSucceeded: _propTypes2.default.bool,
    submitFailed: _propTypes2.default.bool,
    departureServicesById: _propTypes2.default.object.isRequired,
    bookingCompany: _propTypes2.default.object.isRequired
}, _temp)) || _class2) || _class2));

exports.default = TravelReady;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/RequirementSet/forms/TravelReady.js
// module id = 1329
// module chunks = 0